<hoc-grouped-list
  [loading]="loading"
  [groupLetters]="groupLetters"
  [items]="items"
  [loadingBlock]="loadingBlock"
  [footerBlock]="footerBlock"
  [groupBlock]="groupBlock"
  [itemBlock]="itemBlock"
  [emptyItemsBlock]="emptyItemsBlock"
  (scrolledToEnd)="scrolledToEnd()">
</hoc-grouped-list>

<ng-template #groupBlock let-letter>
  <div class="list-title-text">{{ letter }}</div>
</ng-template>

<ng-template #loadingBlock>
  <app-list-placeholder [hasTitle]="true" [columnCount]="2" [lineCount]="1" />
</ng-template>

<ng-template #itemBlock let-item>
  <a [href]="getProjectLink(item)">
    <div class="flex w-full cursor-pointer flex-row border-b border-ui-border p-2">
      <div class="flex-1">{{ item.id }}</div>
      <div class="flex-1">{{ item.name }}</div>
    </div>
  </a>
</ng-template>

<ng-template #emptyItemsBlock>
  <app-empty-details-list-page />
</ng-template>

<ng-template #footerBlock>
  <div #footerContainer class="px-3 py-4">
    <!-- TODO: Add a <gx-button>Load more</gx-button> also with infinite scroll. in case something is not working user has control!-->
    @if (loadMode === 'paged' && items.size > 0) {
      <gx-pagination
        [data]="pagination"
        (newPage)="gotoPage($event)"
        [availablePageSizes]="config.pageSizes"
        [currentPageSize]="filter.pageSize"
        [lengthBeginSegment]="4"
        [lengthEndSegment]="4"
        (newPageSize)="newPageSize($event)" />
    }

    @if (loadMode === 'infinite' && canLoadMore) {
      <app-list-placeholder [hasImageColumn]="true" [columnCount]="3" [lineCount]="2" (click)="scrolledToEnd()" />
    }
  </div>
</ng-template>
